import Vue from 'vue'
import Router from 'vue-router'
import base from './base'
import merchant from './merchant'
import workFlow from './workFlow'
import resources from './resources'
import operation from './operation'
import opration from './opration'
import content from './content'
import supplyInfo from './supplyInfo'
import proj from './proj'


//其他路由暂时不区分了
import  others from './others'
Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法,避免跳转相同路由时控制到报错
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

/* Layout */
import Layout from '../views/layout/layout'

const routes = [
    //以下为通用页
  { path: '/login',
    component:()=>import('../views/login/index')
    // component:resolve => require([views+'login/index'],resolve)
  },
  {
    path: '/',
    component: Layout,
    redirect: '/workbench',
    name: 'Dashboard',
    children: [
      {
        path: 'dashboard',
        // component:()=>import('../views/dashboard/index')
        component:resolve => require(['../views/dashboard/index'],resolve)
      },
      {
        path: 'workbench',
        component:resolve => require(['../views/workbench/index'],resolve),
        name: 'workbench',
        meta: {title: '工作台'}
      }
    ],
  },
  {
    path: '/viewfile',
    name: 'viewfile',
    component:()=>import('../views/viewfile/index'),
    meta: {title: '文件预览'}
  },

    base,
    merchant,
    workFlow,
    resources,
    operation,
    opration,
    content,
    supplyInfo,
    proj,
    ...others,
  {
    path: '/404',
    component:Layout,
    children:[
      {
        path: '/404',
        name: '404',
        component:()=>import('../views/404')
      }]
  },
  {
    path: "*",
    redirect: "/404"
  }
]

export default new Router({
  routes
})

